import type { IObservability } from './createObservability';
import type { IObservabilityContext } from './types';

// ponytail: registry mínimo p/ API imperativa (metrics/logger fora de hooks).
// Swap futuro: DI explícita só; registry some se ninguém precisar fora do React.
let active: IObservability | null = null;

export function setActiveObservability(observability: IObservability | null): void {
  active = observability;
}

export function getActiveObservability(): IObservability {
  if (!active) {
    throw new Error(
      'Observability não inicializada. Monte <ObservabilityProvider> ou chame setActiveObservability.',
    );
  }
  return active;
}

export function tryGetActiveObservability(): IObservability | null {
  return active;
}

/** Contexto da instância ativa — p/ Console metrics/tracing (sem bag de fields). */
export function getActiveObservabilityContext(): IObservabilityContext | undefined {
  const ctx = active?.getContext();
  if (!ctx || Object.keys(ctx).length === 0) return undefined;
  return ctx;
}
